/* tslint:disable */
/* eslint-disable */
/**
 * ServiceTitan.OrgHub.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ModuleDto {
    'id': string;
    'namespace': string;
    'displayName': string;
    'mfeUrl': string;
    'loadType': ModuleLoadType;
    'route': string | null;
    'enabled': boolean;
    'permissions': ModulePermissionsDto;
    'settings': { [key: string]: string; };
    'enablement': ModuleEnablementDto;
    'navSectionId': string | null;
    'navOrder': number | null;
    'surface': ModuleSurface;
}


export interface ModuleEnablementDto {
    'url': string | null;
    'ttlSeconds': number;
    'version': number;
    'fallback': ModuleFallbackMode;
}


export interface ModuleEnablementRequest {
    'enabledUrl': string | null;
    'ttlSeconds': number;
    'version': number;
    'fallback': ModuleFallbackMode;
}



export const ModuleFallbackMode = {
    Hide: 'hide',
    Show: 'show'
} as const;

export type ModuleFallbackMode = typeof ModuleFallbackMode[keyof typeof ModuleFallbackMode];



export const ModuleLoadType = {
    Route: 'route',
    Widget: 'widget'
} as const;

export type ModuleLoadType = typeof ModuleLoadType[keyof typeof ModuleLoadType];



export const ModulePermissionMode = {
    Any: 'any',
    All: 'all'
} as const;

export type ModulePermissionMode = typeof ModulePermissionMode[keyof typeof ModulePermissionMode];


export interface ModulePermissionsDto {
    'mode': ModulePermissionMode;
    'checks': Array<string>;
}


export interface ModulePermissionsRequest {
    'mode': ModulePermissionMode;
    'checks': Array<string>;
}


export interface ModuleSettingRequest {
    'key': string;
    'value': string;
}

export const ModuleSurface = {
    Customer: 'customer',
    Internal: 'internal'
} as const;

export type ModuleSurface = typeof ModuleSurface[keyof typeof ModuleSurface];


export interface ModuleUpsertRequest {
    'id': string;
    'namespace': string;
    'displayName': string;
    'mfeUrl': string;
    'loadType': ModuleLoadType;
    'route': string | null;
    'enabled': boolean;
    'permissions': ModulePermissionsRequest;
    'settings': Array<ModuleSettingRequest>;
    'enablement': ModuleEnablementRequest | null;
    'navSectionId': string;
    'navOrder': number;
    'surface'?: ModuleSurface | null;
}


export interface NavSectionDto {
    'id': string;
    'namespace': string;
    'displayName': string;
    'icon': string | null;
    'order': number;
    'surface': ModuleSurface;
}


export interface UserInfoDto {
    'titanGuid': string;
    'rootOrgId': string | null;
    'name': string | null;
}

/**
 * ModulesApi - axios parameter creator
 */
export const ModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all registered modules including disabled ones (admin)
         * @param {string} rootOrgId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModules: async (rootOrgId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootOrgId' is not null or undefined
            assertParamExists('getAllModules', 'rootOrgId', rootOrgId)
            const localVarPath = `/api/{rootOrgId}/admin/modules`
                .replace(`{${"rootOrgId"}}`, encodeURIComponent(String(rootOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns enabled micro-frontend modules for the given root org (the shell read)
         * @param {string} rootOrgId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModules: async (rootOrgId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootOrgId' is not null or undefined
            assertParamExists('getModules', 'rootOrgId', rootOrgId)
            const localVarPath = `/api/{rootOrgId}/modules`
                .replace(`{${"rootOrgId"}}`, encodeURIComponent(String(rootOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModulesApi - functional programming interface
 */
export const ModulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModulesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all registered modules including disabled ones (admin)
         * @param {string} rootOrgId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllModules(rootOrgId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllModules(rootOrgId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesApi.getAllModules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns enabled micro-frontend modules for the given root org (the shell read)
         * @param {string} rootOrgId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModules(rootOrgId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModules(rootOrgId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesApi.getModules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModulesApi - factory interface
 */
export const ModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModulesApiFp(configuration)
    return {
        /**
         * Returns all registered modules including disabled ones (admin)
         * @param {ModulesApiGetAllModulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllModules(requestParameters: ModulesApiGetAllModulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModuleDto>> {
            return localVarFp.getAllModules(requestParameters.rootOrgId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns enabled micro-frontend modules for the given root org (the shell read)
         * @param {ModulesApiGetModulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModules(requestParameters: ModulesApiGetModulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModuleDto>> {
            return localVarFp.getModules(requestParameters.rootOrgId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllModules operation in ModulesApi.
 */
export interface ModulesApiGetAllModulesRequest {
    readonly rootOrgId: string

    readonly apiVersion?: string
}

/**
 * Request parameters for getModules operation in ModulesApi.
 */
export interface ModulesApiGetModulesRequest {
    readonly rootOrgId: string

    readonly apiVersion?: string
}

/**
 * ModulesApi - object-oriented interface
 */
export class ModulesApi extends BaseAPI {
    /**
     * Returns all registered modules including disabled ones (admin)
     * @param {ModulesApiGetAllModulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllModules(requestParameters: ModulesApiGetAllModulesRequest, options?: RawAxiosRequestConfig) {
        return ModulesApiFp(this.configuration).getAllModules(requestParameters.rootOrgId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns enabled micro-frontend modules for the given root org (the shell read)
     * @param {ModulesApiGetModulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getModules(requestParameters: ModulesApiGetModulesRequest, options?: RawAxiosRequestConfig) {
        return ModulesApiFp(this.configuration).getModules(requestParameters.rootOrgId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ModulesSystemApi - axios parameter creator
 */
export const ModulesSystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModule: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteModule', 'id', id)
            const localVarPath = `/api/system/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemModule: async (id: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSystemModule', 'id', id)
            const localVarPath = `/api/system/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ModuleUpsertRequest} moduleUpsertRequest 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModule: async (id: string, moduleUpsertRequest: ModuleUpsertRequest, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertModule', 'id', id)
            // verify required parameter 'moduleUpsertRequest' is not null or undefined
            assertParamExists('upsertModule', 'moduleUpsertRequest', moduleUpsertRequest)
            const localVarPath = `/api/system/modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleUpsertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModulesSystemApi - functional programming interface
 */
export const ModulesSystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModulesSystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteModule(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteModule(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesSystemApi.deleteModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSystemModule(id: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSystemModule(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesSystemApi.getSystemModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ModuleUpsertRequest} moduleUpsertRequest 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertModule(id: string, moduleUpsertRequest: ModuleUpsertRequest, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertModule(id, moduleUpsertRequest, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesSystemApi.upsertModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModulesSystemApi - factory interface
 */
export const ModulesSystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModulesSystemApiFp(configuration)
    return {
        /**
         * 
         * @param {ModulesSystemApiDeleteModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModule(requestParameters: ModulesSystemApiDeleteModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteModule(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ModulesSystemApiGetSystemModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemModule(requestParameters: ModulesSystemApiGetSystemModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ModuleDto> {
            return localVarFp.getSystemModule(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ModulesSystemApiUpsertModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertModule(requestParameters: ModulesSystemApiUpsertModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.upsertModule(requestParameters.id, requestParameters.moduleUpsertRequest, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteModule operation in ModulesSystemApi.
 */
export interface ModulesSystemApiDeleteModuleRequest {
    readonly id: string

    readonly apiVersion?: string
}

/**
 * Request parameters for getSystemModule operation in ModulesSystemApi.
 */
export interface ModulesSystemApiGetSystemModuleRequest {
    readonly id: string

    readonly apiVersion?: string
}

/**
 * Request parameters for upsertModule operation in ModulesSystemApi.
 */
export interface ModulesSystemApiUpsertModuleRequest {
    readonly id: string

    readonly moduleUpsertRequest: ModuleUpsertRequest

    readonly apiVersion?: string
}

/**
 * ModulesSystemApi - object-oriented interface
 */
export class ModulesSystemApi extends BaseAPI {
    /**
     * 
     * @param {ModulesSystemApiDeleteModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteModule(requestParameters: ModulesSystemApiDeleteModuleRequest, options?: RawAxiosRequestConfig) {
        return ModulesSystemApiFp(this.configuration).deleteModule(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ModulesSystemApiGetSystemModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSystemModule(requestParameters: ModulesSystemApiGetSystemModuleRequest, options?: RawAxiosRequestConfig) {
        return ModulesSystemApiFp(this.configuration).getSystemModule(requestParameters.id, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ModulesSystemApiUpsertModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertModule(requestParameters: ModulesSystemApiUpsertModuleRequest, options?: RawAxiosRequestConfig) {
        return ModulesSystemApiFp(this.configuration).upsertModule(requestParameters.id, requestParameters.moduleUpsertRequest, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NavSectionsApi - axios parameter creator
 */
export const NavSectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all registered navigation sections, ordered by Order
         * @param {string} rootOrgId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavSections: async (rootOrgId: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootOrgId' is not null or undefined
            assertParamExists('getNavSections', 'rootOrgId', rootOrgId)
            const localVarPath = `/api/{rootOrgId}/nav-sections`
                .replace(`{${"rootOrgId"}}`, encodeURIComponent(String(rootOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NavSectionsApi - functional programming interface
 */
export const NavSectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NavSectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all registered navigation sections, ordered by Order
         * @param {string} rootOrgId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavSections(rootOrgId: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NavSectionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavSections(rootOrgId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavSectionsApi.getNavSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NavSectionsApi - factory interface
 */
export const NavSectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NavSectionsApiFp(configuration)
    return {
        /**
         * Returns all registered navigation sections, ordered by Order
         * @param {NavSectionsApiGetNavSectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavSections(requestParameters: NavSectionsApiGetNavSectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NavSectionDto>> {
            return localVarFp.getNavSections(requestParameters.rootOrgId, requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNavSections operation in NavSectionsApi.
 */
export interface NavSectionsApiGetNavSectionsRequest {
    readonly rootOrgId: string

    readonly apiVersion?: string
}

/**
 * NavSectionsApi - object-oriented interface
 */
export class NavSectionsApi extends BaseAPI {
    /**
     * Returns all registered navigation sections, ordered by Order
     * @param {NavSectionsApiGetNavSectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNavSections(requestParameters: NavSectionsApiGetNavSectionsRequest, options?: RawAxiosRequestConfig) {
        return NavSectionsApiFp(this.configuration).getNavSections(requestParameters.rootOrgId, requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the authenticated caller\'s TitanGuid, resolved root org id, and display name
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the authenticated caller\'s TitanGuid, resolved root org id, and display name
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Returns the authenticated caller\'s TitanGuid, resolved root org id, and display name
         * @param {UserApiGetUserInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(requestParameters: UserApiGetUserInfoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserInfoDto> {
            return localVarFp.getUserInfo(requestParameters.apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getUserInfo operation in UserApi.
 */
export interface UserApiGetUserInfoRequest {
    readonly apiVersion?: string
}

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * Returns the authenticated caller\'s TitanGuid, resolved root org id, and display name
     * @param {UserApiGetUserInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserInfo(requestParameters: UserApiGetUserInfoRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserInfo(requestParameters.apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



